module.exports = __webpack_public_path__ + "static/media/ID.9ea159ec.svg";